import { GetUserQueryItem } from '../data/useGetUser';

export const nameStatus = (user: GetUserQueryItem | null) => {
  const name = !user
    ? 'Unallocated'
    : !user?.fullName
      ? 'Unknown'
      : user.fullName;

  const isActive = user?.active === true;
  const isLicensed = user?.licensed === true;

  const status = statusSuffix(isActive, isLicensed);

  return `${name} ${status}`;
};

export const statusSuffix = (active: boolean, licensed: boolean) => {
  if (!licensed) return '(unlicensed)';
  else if (!active) return '(inactive)';

  return '';
};
